import { useEffect, useState } from 'react';
import {
  aplicaSalvaContacorrente,
  finalizaJornadaCessao,
  listarContasCorrentes,
  validaTitulosCedidos
} from 'api/capitalFlow';
import { openSnackbarMain } from 'components/Shared/openSnackbarMain';
import { useNavegacao } from 'hooks/useNavegacao';
import { SUBMENUS } from 'components/Shared/Enums/SubMenusEnum';

const useContaCorrenteCessaoHook = ({ setCarregarTela, setEscopoAcesso }) => {
  const [accounts, setAccounts] = useState([]);
  const [loadingContas, setLoadingContas] = useState(true);
  const [contaSelecionada, setContaSelecionada] = useState(null);
  const [contaSelecionadaControle, setContaSelecionadaControle] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [openDialogConfirmacao, setOpenDialogConfirmacao] = useState(false);
  const [openModalCancelar, setOpenModalCancelar] = useState(false);
  const [loadingProsseguir, setLoadingProsseguir] = useState(false);
  const [loadingBtnConfirmarConta, setLoadingBtnConfirmarConta] = useState(false);
  const [openModalFinalizaCessao, setOpenModalFinalizaCessao] = useState(false);
  const [textoConfirmacao, setTextoConfirmacao] = useState('');
  const [openModalTitulosCedidos, setOpenModalTitulosCedidos] = useState(false);
  const { navegarTela } = useNavegacao({ setEscopoAcesso });

  useEffect(() => {
    buscarContasCorrentes();
  }, []);

  const buscarContasCorrentes = async () => {
    setLoadingContas(true);
    try {
      const res = await listarContasCorrentes();
      setAccounts(res?.data?.data ?? []);
      setContaSelecionada(res?.data?.conta_selelecionada ?? null);
    } catch (err) {
      openSnackbarMain('Ocorreu um erro ao buscar as contas correntes', 'error');
      console.error('Ocorreu um erro ao buscar as contas correntes', err);
    } finally {
      setLoadingContas(false);
    }
  };

  const voltarParaUpload = () => {
    setCarregarTela('UploadCessao');
  };

  const handleOpenDialog = () => {
    if (!loadingProsseguir) {
      setOpenDialog(true);
    }
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleOpenDialogConfirmacao = codContaCorrente => {
    if (!loadingProsseguir) {
      if (codContaCorrente && codContaCorrente !== contaSelecionada) {
        setContaSelecionadaControle(codContaCorrente);
        setOpenDialogConfirmacao(true);
      } else {
        setContaSelecionada(false);
      }
    }
  };

  const handleCloseDialogConfirmacao = () => {
    setOpenDialogConfirmacao(false);
  };

  const aplicaContacorrente = () => {
    setLoadingBtnConfirmarConta(true);
    const params = { uuid_conta: contaSelecionadaControle };
    aplicaSalvaContacorrente(params)
      .then(() => {
        setContaSelecionada(contaSelecionadaControle);
      })
      .catch(err => {
        openSnackbarMain('Ocorreu um erro ao escolher a conta corrente', 'error');
        console.error('Ocorreu um erro ao escolher a conta corrente', err);
      })
      .finally(() => {
        handleCloseDialogConfirmacao();
        setLoadingBtnConfirmarConta(false);
      });
  };

  const finalizarCessao = () => {
    setLoadingProsseguir(true);
    finalizaJornadaCessao()
      .then(result => {
        verificaRetornoFinalizaJornadaCessao(result.data);
      })
      .catch(err => {
        setLoadingProsseguir(false);
        openSnackbarMain('Ocorreu um erro ao finalizar a cessão', 'error');
        console.error('Erro ao finalizar a cessão', err);
      });
  };

  const verificaRetornoFinalizaJornadaCessao = retorno => {
    if (retorno.mensagem !== '') {
      setTextoConfirmacao(retorno?.mensagem);
      setOpenModalFinalizaCessao(true);
    } else {
      irParaTelaHistoricoCessao();
    }
  };

  const irParaTelaHistoricoCessao = () => {
    onCloseFinalizaCessao();
    setLoadingProsseguir(false);
    const telaCapitalFlow = SUBMENUS.CAPITAL_FLOW;
    navegarTela(
      telaCapitalFlow.CODSUBMENU,
      telaCapitalFlow.CAMINHO,
      telaCapitalFlow.PROJETO,
      telaCapitalFlow.CODDEPARTAMENTO
    );
  };

  const onCloseModalCancelar = () => {
    setOpenModalCancelar(false);
  };

  const onCloseFinalizaCessao = () => {
    setOpenModalFinalizaCessao(false);
  };

  const verificaTitulosCedidos = () => {
    setLoadingProsseguir(true);
    validaTitulosCedidos()
      .then(response => {
        if (response.data?.existe_conflito) {
          setOpenModalTitulosCedidos(true);
          setLoadingProsseguir(false);
        } else {
          finalizarCessao();
        }
      })
      .catch(() => {
        setLoadingProsseguir(false);
        openSnackbarMain('Ocorreu um erro ao validar os títulos cedidos', 'error');
      });
  };

  const onCloseModalTitulosCedidos = () => {
    setOpenModalTitulosCedidos(false);
  };

  return {
    handleCloseDialogConfirmacao,
    handleOpenDialogConfirmacao,
    onCloseModalTitulosCedidos,
    irParaTelaHistoricoCessao,
    loadingBtnConfirmarConta,
    openModalFinalizaCessao,
    openModalTitulosCedidos,
    verificaTitulosCedidos,
    onCloseFinalizaCessao,
    buscarContasCorrentes,
    openDialogConfirmacao,
    onCloseModalCancelar,
    setOpenModalCancelar,
    aplicaContacorrente,
    openModalCancelar,
    handleCloseDialog,
    textoConfirmacao,
    loadingProsseguir,
    handleOpenDialog,
    voltarParaUpload,
    contaSelecionada,
    finalizarCessao,
    loadingContas,
    openDialog,
    accounts
  };
};

export default useContaCorrenteCessaoHook;
